import { useEffect, useRef, useState } from "react";

function CounterTimer({ handelCounterScreen }) {
    const [counterTimer, setCounterTimer] = useState(3);
    const [counterScreen, setCounterScreen] = useState(true);
    const counterTimerRef = useRef();


    useEffect(() => {
        if (counterTimer > 0) {
            counterTimerRef.current = setInterval(handleCounterTimer, 1000);
            return () => clearInterval(counterTimerRef.current);
        }
    }, []);

    const handleCounterTimer = () => {
        setCounterTimer((prev) => {
            if (prev === 1) {
                clearInterval(counterTimerRef.current);
                setCounterScreen(false)
                handelCounterScreen()
            }
            return prev - 1;
        });
    };


    return (
        counterScreen ?
            <div className="counter-main">
                <div className="counter-timer">{counterTimer}</div>
            </div>
            : null
    );
}

export default CounterTimer